import React from 'react';
import { useHits } from 'react-instantsearch';

const DownloadCards = (props) => {
    // eslint-disable-next-line no-unused-vars
    const { hits, sendEvent } = useHits(props);

    if (window.filtersInit) {
        document.getElementById('listing').scrollIntoView({behavior: 'instant'});
    } else {
        setTimeout(function() {
            window.filtersInit = true;
        }, 1000)
    }

    if (hits.length) {
        return (
            <section className="flex flex-col gap-6">
                {hits.map((hit) => (
                    <article key={hit.objectID} className="border border-grey-300 flex gap-3 p-4 md:items-center md:gap-8 md:p-8">

                        <div className="w-6 mt-1 sm:mt-1.5 md:mt-0 md:w-12">
                            <a data-event='{"category": "Downloads", "action": "Clicked Image", "label": "${ hit.title }"}' target="_blank" rel="noreferrer nofollow noindex" href={ hit.url }>
                                <img className="w-full h-auto" src={ hit.image } alt={ hit.alt } aria-hidden="true" />
                            </a>
                        </div>

                        <div className="flex-1">
                            <h2 className="font-bold text-lg md:text-xl">
                                <a data-event='{"category": "Downloads", "action": "Clicked Title", "label": "${ hit.title }"}' target="_blank" rel="noreferrer nofollow noindex" href={ hit.url } className="underline underline-offset-2 decoration-transparent transition duration-300 ease-linear hover:decoration-black">
                                    { hit.title }
                                </a>
                            </h2>
                            <div className="mt-2 prose text-sm">
                                <p>{ hit.copy }</p>
                            </div>
                        </div>

                        <div className="w-20 text-right hidden md:block">
                            <a data-event='{"category": "Downloads", "action": "Clicked Download", "label": "${ hit.title }"}' target="_blank" rel="noreferrer nofollow noindex" href={ hit.url } className="inline-block opacity-75 transition duration-300 ease-linear hover:opacity-100">
                                <svg className="inline-block" width="31" height="32" viewBox="0 0 31 32" xmlns="http://www.w3.org/2000/svg"><path d="M15.5.5C6.94.5 0 7.44 0 16c0 8.56 6.94 15.5 15.5 15.5C24.06 31.5 31 24.56 31 16 31 7.44 24.06.5 15.5.5zm-4.099 14.957a.512.512 0 01.472-.302h2.074V8.417c0-.285.23-.515.516-.515h2.074c.285 0 .516.23.516.515v6.738h2.074c.203 0 .39.12.472.302.082.186.054.4-.083.554l-3.626 4.148a.528.528 0 01-.39.176.528.528 0 01-.39-.176l-3.626-4.148a.501.501 0 01-.083-.554zm9.41 8.647H10.19a.721.721 0 01-.719-.719c0-.395.324-.719.719-.719H20.81c.395 0 .719.324.719.72a.721.721 0 01-.719.718z" fill="#414248" fillRule="nonzero" opacity=".6"/></svg>
                            </a>
                        </div>
                    </article>
                ))}
            </section>
        );
    } else {
        setTimeout(function() {
            document.getElementById('no-results')?.classList.remove('hidden');
        }, 500)

        return (
            <div id="no-results" className="border-2 border-grey-200 rounded p-6 sm:p-8 text-center max-w-screen-md mx-auto w-full hidden">
                <p className="font-bold text-green text-xl">{props.noresultsHeading}</p>
                <p className="text-sm md:text-base mt-2">{props.noresultsText}</p>
            </div>
        );
    }

}

export { DownloadCards }
